module.exports = __webpack_public_path__ + "static/img/product_banner_24_zh.f9f2cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_24_zh.png
// module id = +1g3
// module chunks = 34